// src/pages/UnauthorizedPage.tsx
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      gap={2}
      sx={{ p: 3 }}
    >
      <Typography variant="h4" component="h1">
        Access Denied
      </Typography>
      <Typography variant="body1" color="text.secondary" textAlign="center">
        You don't have permission to access this page.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/')}>
        Go to Home
      </Button>
    </Box>
  );
}

